<div *ngIf="(isLoading$ | async) || (parentIsLoading | async)" class="spinner-overlay">
  <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>
<div
  class="integration"
  *ngIf="(parentIsLoading | async) === false && !showNoData && integrationFormGroup"
  [class.content-hidden]="isLoading$ | async"
>
  <div class="side-strip"></div>

  <div class="integration-header">
    <div class="integration-header-page-title">
      {{ (isInAddMode ? 'integrationPage.addTitle' : 'integrationPage.editTitle') | labelsProvider }}
    </div>
    <img class="integration-header-close-button" src="assets/images/common/cancel.svg" (click)="closeWindow()" />
  </div>
  <div class="integration-header-border"></div>
  <div *ngIf="integrationId && (errorMessage | async)" class="integration-error">
    <img class="integration-error-icon" src="assets/images/common/fail-notification.svg" />
    <div class="integration-error-text">
      {{ errorMessage | async }}
    </div>
  </div>
  <div class="integration-content">
    <app-detail-keyvalue [isInAddOrEditMode]="false" [input]="integrationNameDetail"> </app-detail-keyvalue>

    <app-integration-environment
      [inAddMode]="!this.integrationId"
      [environmentFormControl]="integrationFormGroup.controls['environment']"
    >
    </app-integration-environment>

    <app-integration-platform-selection
      [disabled]="this.integrationId !== undefined"
      [platformFormControl]="integrationFormGroup.controls['platform']"
    >
    </app-integration-platform-selection>

    <div class="integration-content-separator" *ngIf="integrationFormGroup.controls['platform'].value"></div>

    <div [ngClass]="{ 'devices-auth-wrapper': integrationFormGroup.controls['platform'].value === 'devices' }">
      <app-integration-auth-method
        [platformControl]="integrationFormGroup.controls['platform']"
        [authMethodControl]="integrationFormGroup.controls['authMethod']"
        [isInAddMode]="this.integrationId === undefined"
      >
      </app-integration-auth-method>

      @if (
        integrationFormGroup.controls['platform'].value === 'devices' &&
        integrationFormGroup.controls['authMethod'].value === 'enrollment-key' &&
        this.integrationId === undefined
      ) {
        <div class="devices-enrollment-key-info">
          {{ 'integrationPage.authDescriptions.devicesEnrollmentKeyPreCreationInfo' | labelsProvider }}
        </div>
      }

      @if (
        integrationFormGroup.controls['platform'].value === 'cursor' &&
        integrationFormGroup.controls['authMethod'].value === 'enrollment-key' &&
        this.integrationId === undefined
      ) {
        <div class="devices-enrollment-key-info">
          {{ 'integrationPage.cursorHooks.preCreationInfo' | labelsProvider }}
        </div>
      }

      <app-devices-enrollment-key
        *ngIf="integrationFormGroup.controls['platform'].value === 'devices' && this.integrationId !== undefined"
        [enrollmentKey]="devicesEnrollmentKey"
      >
      </app-devices-enrollment-key>

      <app-cursor-hooks-download
        *ngIf="integrationFormGroup.controls['platform'].value === 'cursor' && this.integrationId !== undefined"
        [integrationId]="integrationId"
        [hasEnrollmentKey]="!!devicesEnrollmentKey"
      >
      </app-cursor-hooks-download>
    </div>

    <app-integration-credentials
      [platformControl]="integrationFormGroup.controls['platform']"
      [authMethodControl]="integrationFormGroup.controls['authMethod']"
      [credentialsFormGroup]="credentialsFormGroup"
      [integrationCredentials]="integrationCredentials"
      [isInAddMode]="this.integrationId === undefined"
      [formSubmitAttempt]="formSubmitAttempt"
      [shouldUpdateCredentials]="shouldUpdateCredentials"
    >
    </app-integration-credentials>

    <!-- Create mode disabled toggle preview -->
    @if (shouldShowCreateModeInlinePreview()) {
      <div class="inline-webhook-preview-container">
        <div class="inline-webhook-preview">
          <div class="inline-webhook-preview-left">
            <mat-icon class="inline-webhook-preview-icon">chevron_right</mat-icon>
            <span class="inline-webhook-preview-title">
              {{ 'integrationPage.inLineWebhookService.title' | labelsProvider }}
            </span>
          </div>
          <div class="inline-webhook-preview-right">
            <mat-slide-toggle [checked]="false" [disabled]="true" color="primary"> </mat-slide-toggle>
          </div>
        </div>
        <div class="inline-webhook-preview-hint">
          {{ 'integrationPage.inlineWebhookDisabledPreviewText' | labelsProvider }}
        </div>
      </div>
    }

    <!-- Edit mode In-line Webhook Section - BEFORE buttons -->
    @if (shouldShowInlineControlSection() && inLineIntegrationFormGroup && this.integrationId !== undefined) {
      <div class="inline-webhook-accordion">
        <!-- Main In-line Webhook Header -->
        <div class="accordion-header" [class.collapsed]="!inlineWebhookExpanded()">
          <div class="accordion-header-left">
            <mat-icon class="accordion-header-icon" [class.expanded]="inlineWebhookExpanded()">
              chevron_right
            </mat-icon>
            <span class="accordion-header-title">
              {{ 'integrationPage.inLineWebhookService.title' | labelsProvider }}
            </span>
          </div>
          <div class="accordion-header-right">
            <mat-slide-toggle
              [formControl]="inLineIntegrationFormGroup.controls.inLineServiceEnabled"
              color="primary"
              (change)="onMainInlineToggleChange($event)"
            >
            </mat-slide-toggle>
          </div>
        </div>

        @if (inlineWebhookExpanded()) {
          <div class="accordion-content">
            <div class="accordion-content-description">
              <p>
                {{ 'integrationPage.inLineWebhookService.description' | labelsProvider }}
              </p>
            </div>

            <!-- Shared Tenant ID -->
            <div class="inline-webhook-field">
              <div class="custom-detail-field">
                <div class="custom-detail-key">
                  {{ 'integrationPage.tenantIdLabel' | labelsProvider }}
                </div>
                <div class="custom-detail-value-container">
                  <div class="custom-detail-value readonly">
                    {{ credentialsFormGroup.get(credentialKey.tenantId)?.value || '' }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Copilot Studio Section -->
            <div class="inline-subsection">
              <div class="inline-subsection-header">
                <div class="inline-subsection-header-left">
                  <div class="inline-subsection-header-text">
                    <h3 class="inline-subsection-title">
                      {{ 'integrationPage.copilotStudioSectionTitle' | labelsProvider }}
                    </h3>
                    <p class="inline-subsection-description">
                      {{ 'integrationPage.copilotStudioDescription' | labelsProvider }}
                    </p>
                  </div>
                </div>
                <div class="inline-subsection-header-right">
                  <mat-slide-toggle
                    [checked]="copilotStudioEnabled()"
                    color="primary"
                    (change)="onCopilotStudioToggleChange($event)"
                  >
                  </mat-slide-toggle>
                </div>
              </div>

              @if (copilotStudioEnabled()) {
                <div class="inline-subsection-content">
                  <div class="accordion-content-guide">
                    <h4 class="accordion-content-guide-title">
                      {{ 'integrationPage.inLineWebhookService.guideTitle' | labelsProvider }}
                    </h4>
                    <p class="accordion-content-guide-description">
                      {{ 'integrationPage.inLineWebhookService.guideDescription' | labelsProvider }}
                    </p>
                    <div class="accordion-content-guide-link-container">
                      <a
                        href="https://docs.zenity.io/UserGuide/ZenityUG_Inline_Prevention.html"
                        class="accordion-content-guide-link"
                        target="_blank"
                      >
                        {{ 'integrationPage.inLineWebhookService.pdfLinkText' | labelsProvider }}
                      </a>
                    </div>
                  </div>

                  <div class="inline-webhook-field">
                    <div class="custom-detail-field">
                      <div class="custom-detail-key">
                        {{ 'integrationPage.foundryService.applicationIdLabel' | labelsProvider }}
                      </div>
                      <div class="custom-detail-value-container">
                        <input
                          type="text"
                          class="custom-detail-input"
                          [formControl]="inLineIntegrationFormGroup.controls.inLineServiceApplicationId"
                          placeholder="Enter Application ID"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="inline-subsection-footer">
                    <button
                      class="save-webhook-button"
                      (click)="onSaveInlineIntegration()"
                      [class.disabled]="inLineIntegrationFormGroup.invalid"
                      [disabled]="inLineIntegrationFormGroup.invalid"
                    >
                      {{ 'integrationPage.inLineWebhookService.saveButton' | labelsProvider }}
                    </button>
                  </div>
                </div>
              }
            </div>

            <!-- Microsoft Foundry Section -->
            @if (foundryFormGroup) {
              <div class="inline-subsection">
                <div class="inline-subsection-header">
                  <div class="inline-subsection-header-left">
                    <div class="inline-subsection-header-text">
                      <h3 class="inline-subsection-title">
                        {{ 'integrationPage.foundryServiceSectionTitle' | labelsProvider }}
                      </h3>
                      <p class="inline-subsection-description">
                        {{ 'integrationPage.foundryService.description' | labelsProvider }}
                      </p>
                    </div>
                  </div>
                  <div class="inline-subsection-header-right">
                    <mat-slide-toggle
                      [formControl]="foundryFormGroup.controls.foundryEnabled"
                      color="primary"
                      (change)="onFoundryToggleChange($event)"
                    >
                    </mat-slide-toggle>
                  </div>
                </div>

                @if (foundryEnabled()) {
                  <div class="inline-subsection-content">
                    <div class="accordion-content-guide">
                      <h4 class="accordion-content-guide-title">
                        {{ 'integrationPage.foundryService.guideTitle' | labelsProvider }}
                      </h4>
                      <p class="accordion-content-guide-description">
                        {{ 'integrationPage.foundryService.guideDescription' | labelsProvider }}
                      </p>
                      <div class="accordion-content-guide-link-container">
                        <a
                          href="https://docs.zenity.io/UserGuide/ZenityUG_Inline_Prevention.html#azure-ai-foundry"
                          class="accordion-content-guide-link"
                          target="_blank"
                        >
                          {{ 'integrationPage.foundryService.pdfLinkText' | labelsProvider }}
                        </a>
                      </div>
                    </div>

                    <div class="foundry-api-key-notice">
                      {{ 'integrationPage.foundryService.apiKeyRequiredNotice' | labelsProvider }}
                    </div>

                    <!-- API Key Section -->
                    <div class="inline-webhook-field">
                      <div class="custom-detail-field">
                        <div class="custom-detail-key">
                          {{ 'integrationPage.foundryService.apiKeyLabel' | labelsProvider }}
                        </div>
                        <div class="api-key-row">
                          <input type="text" class="api-key-input" [value]="getDisplayApiKey()" readonly />
                          <button
                            class="api-key-button generate"
                            (click)="onGenerateFoundryApiKey()"
                            [disabled]="foundryApiKeyExists()"
                            [class.disabled]="foundryApiKeyExists()"
                          >
                            {{ 'integrationPage.foundryService.generateApiKeyButton' | labelsProvider }}
                          </button>
                          @if (foundryApiKeyExists()) {
                            <button
                              class="api-key-button copy"
                              (click)="onCopyFoundryApiKey()"
                              [class.copied]="foundryApiKeyCopied()"
                              [disabled]="!foundryApiKeyVisible()"
                              [class.disabled]="!foundryApiKeyVisible()"
                            >
                              @if (foundryApiKeyCopied()) {
                                <lucide-icon name="check" [size]="16" [strokeWidth]="2"></lucide-icon>
                              } @else {
                                <lucide-icon name="copy" [size]="16" [strokeWidth]="2"></lucide-icon>
                              }
                            </button>
                          }
                          @if (foundryApiKeyExists()) {
                            <button class="api-key-button revoke" (click)="onRevokeFoundryApiKey()">
                              {{ 'integrationPage.foundryService.revokeApiKeyButton' | labelsProvider }}
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <!-- Footer with Cancel/Save buttons -->
  <div
    [ngClass]="{
      'integration-footer-inline': shouldShowInlineControlSection() || shouldShowCreateModeInlinePreview(),
      'integration-footer': !shouldShowInlineControlSection() && !shouldShowCreateModeInlinePreview(),
    }"
  >
    <div class="integration-buttons-container">
      @if (isDevicesIntegrationCreatedWithKey()) {
        <button class="integration-button" (click)="closeWindow(true)">Done</button>
      } @else {
        <button class="integration-button-cancel" (click)="onCancel()">
          {{ 'integrationPage.cancelButton' | labelsProvider }}
        </button>

        @if (this.integrationId === undefined) {
          <button
            class="integration-button"
            (click)="formSubmitAttempt = true; onAddIntegration()"
            [ngClass]="{
              'integration-button-disabled': integrationFormGroup.invalid,
            }"
            [disabled]="integrationFormGroup.invalid"
          >
            {{ 'integrationPage.createButton' | labelsProvider }}
          </button>
        }
        @if (this.integrationId !== undefined) {
          <button
            class="integration-button"
            (click)="formSubmitAttempt = true; onUpdate()"
            [ngClass]="{
              'integration-button-disabled': integrationFormGroup.invalid,
            }"
            [disabled]="integrationFormGroup.invalid"
          >
            {{ 'integrationPage.saveButton' | labelsProvider }}
          </button>
        }
      }
    </div>
  </div>
</div>
